import React from 'react';

interface ILoaderContext {
	loader: any;
	setLoader: any;
}

const LoaderContext = React.createContext<ILoaderContext>({} as ILoaderContext);

export default LoaderContext;
